module.exports = __webpack_public_path__ + "media/images/list_practice/5-01-95a9dd98acceb03535d1993a0a0e4152.svg";